import { render, staticRenderFns } from "./SettingsVerifyEmail.vue?vue&type=template&id=5a0dc1ae&scoped=true&"
import script from "./SettingsVerifyEmail.vue?vue&type=script&lang=js&"
export * from "./SettingsVerifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./SettingsVerifyEmail.vue?vue&type=style&index=0&id=5a0dc1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0dc1ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a0dc1ae')) {
      api.createRecord('5a0dc1ae', component.options)
    } else {
      api.reload('5a0dc1ae', component.options)
    }
    module.hot.accept("./SettingsVerifyEmail.vue?vue&type=template&id=5a0dc1ae&scoped=true&", function () {
      api.rerender('5a0dc1ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/SettingsVerifyEmail.vue"
export default component.exports